/* Pohjoisen Rent – saatavuuskalenteri (kaikki laitteet × päivät) */
(() => {
  const MIN_DAY = 24 * 60;
  class PrAvailability extends HTMLElement {
    connectedCallback() {
      try { this.data = JSON.parse(this.querySelector('script[type="application/json"]').textContent); } catch (e) { console.error(e); return; }
      const d = this.data;
      this.tz = d.timezone || 'Europe/Helsinki';
      this.locale = d.locale || 'fi';
      this.t = d.i18n;
      this.staff = !!d.staff;
      this.devices = d.devices.map((dev) => {
        const busy = [];
        /* Varausrivit: TILAUS;ALKU;LOPPU;MÄÄRÄ – erottimena | (Shopify Flow) tai rivinvaihto (käsin) */
        (dev.bookings || []).map(String).join('\n').split(/[|\n\r]+/).forEach((line) => {
          line = String(line).trim(); if (!line) return;
          const p = line.split(';').map((x) => x.trim()); if (p.length < 3) return;
          const s = this.parseWall(p[1]), e = this.parseWall(p[2]); if (s === null || e === null) return;
          busy.push({ n: p[0], s, e: e + (dev.buffer || 0) * 60, q: parseInt(p[3] || '1', 10) || 1, kind: 'order' });
        });
        (dev.blocks || []).forEach((b) => {
          const s = this.parseWall(b.s), e = this.parseWall(b.e); if (s === null || e === null) return;
          busy.push({ n: b.n, s, e: e + (dev.buffer || 0) * 60, q: b.q || 1, kind: 'block' });
        });
        return { ...dev, busy, capacity: Math.max(1, dev.capacity || 1) };
      });
      const now = this.instantToWall(new Date());
      this.today = this.dayStart(now);
      this.view = this.monthStart(this.today);
      this.render();
    }
    parseWall(s) {
      if (!s) return null; s = String(s).trim();
      const m = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2}))?(?:\.\d+)?(Z|[+-]\d{2}:?\d{2})?)?$/);
      if (!m) return null;
      if (m[7]) return this.instantToWall(new Date(s));
      return Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0)) / 60000;
    }
    instantToWall(date) {
      const parts = new Intl.DateTimeFormat('en-GB', { timeZone: this.tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(date);
      const o = {}; parts.forEach((p) => { o[p.type] = p.value; });
      return Date.UTC(+o.year, +o.month - 1, +o.day, +o.hour % 24, +o.minute) / 60000;
    }
    wallDate(w) { return new Date(w * 60000); }
    dayStart(w) { return Math.floor(w / MIN_DAY) * MIN_DAY; }
    monthStart(w) { const d = this.wallDate(w); return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1) / 60000; }
    addMonths(w, n) { const d = this.wallDate(w); return Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + n, 1) / 60000; }
    fmtMonth(w) { return new Intl.DateTimeFormat(this.locale, { month: 'long', year: 'numeric', timeZone: 'UTC' }).format(this.wallDate(w)); }
    fmtTime(w) { const d = this.wallDate(w); return `${String(d.getUTCHours()).padStart(2, '0')}:${String(d.getUTCMinutes()).padStart(2, '0')}`; }
    fmtDT(w) { const d = this.wallDate(w); return `${d.getUTCDate()}.${d.getUTCMonth() + 1}. ${this.fmtTime(w)}`; }
    usage(dev, s, e) {
      const evs = [];
      for (const b of dev.busy) if (b.s < e && b.e > s) evs.push([Math.max(b.s, s), b.q], [Math.min(b.e, e), -b.q]);
      if (!evs.length) return { min: 0, max: 0 };
      evs.sort((a, b) => a[0] - b[0] || a[1] - b[1]);
      let cur = 0, max = 0, min = Infinity, t = s;
      for (const [time, q] of evs) { if (time > t) { min = Math.min(min, cur); t = time; } cur += q; max = Math.max(max, cur); }
      if (t < e) min = Math.min(min, cur);
      if (min === Infinity) min = 0;
      return { min, max };
    }
    render() {
      const t = this.t;
      const ms = this.view, me = this.addMonths(ms, 1);
      const days = []; for (let d = ms; d < me; d += MIN_DAY) days.push(d);
      const wd = new Intl.DateTimeFormat(this.locale, { weekday: 'narrow', timeZone: 'UTC' });
      let html = `<div class="pra__head"><button type="button" class="pra__nav" data-nav="-1" aria-label="${t.prev}">&lsaquo;</button><h3 class="pra__month">${this.fmtMonth(ms)}</h3><button type="button" class="pra__nav" data-nav="1" aria-label="${t.next}">&rsaquo;</button></div>`;
      html += `<div class="pra__legend"><span class="pra__lg pra__lg--free">${t.free}</span><span class="pra__lg pra__lg--partial">${t.partial}</span><span class="pra__lg pra__lg--full">${t.full}</span></div>`;
      html += `<div class="pra__scroll"><table class="pra__table"><thead><tr><th class="pra__dev"></th>${days.map((d) => { const dd = this.wallDate(d); const we = [0, 6].includes(dd.getUTCDay()); return `<th class="pra__d${we ? ' pra__d--we' : ''}${d === this.today ? ' pra__d--today' : ''}"><span>${wd.format(dd)}</span><b>${dd.getUTCDate()}</b></th>`; }).join('')}</tr></thead><tbody>`;
      for (const dev of this.devices) {
        html += `<tr><th class="pra__dev"><a href="${dev.url}">${this.esc(dev.title)}</a>${dev.capacity > 1 ? `<small>${dev.capacity} ${t.units}</small>` : ''}</th>`;
        for (const d of days) {
          const u = this.usage(dev, d, d + MIN_DAY);
          let st = 'free';
          if (d < this.today) st = 'past';
          else if (u.min >= dev.capacity) st = 'full';
          else if (u.max >= dev.capacity) st = 'partial';
          else if (u.max > 0) st = 'some';
          let title = '';
          if (this.staff) {
            const hits = dev.busy.filter((b) => b.s < d + MIN_DAY && b.e > d).map((b) => `${b.n}: ${this.fmtDT(b.s)} → ${this.fmtDT(b.e)}`);
            title = hits.join('\n');
          }
          html += `<td class="pra__c pra__c--${st}"${title ? ` title="${this.esc(title)}"` : ''}>${this.staff && title ? '<i></i>' : ''}</td>`;
        }
        html += '</tr>';
      }
      html += '</tbody></table></div>';
      if (this.staff) html += `<p class="pra__note">${t.staff_note}</p>`;
      this.innerHTML = html;
      this.querySelectorAll('[data-nav]').forEach((b) => b.addEventListener('click', () => { this.view = this.addMonths(this.view, +b.dataset.nav); this.render(); }));
    }
    esc(s) { return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }
  }
  if (!customElements.get('pr-availability')) customElements.define('pr-availability', PrAvailability);
})();
